// extracted by mini-css-extract-plugin
export default {"name":"name-k08oD","note":"note-dN9lo","deploy":"deploy-VTRmb","description":"description-bEdEF","budget":"budget-oQwXG"};